import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from './pages/Home/index';
import Footer from './components/Footer/index';
import MemberPop from './components/MemPopUp/index';
// import Facilities from './pages/Facilities/index';
// import SpecialOffers from './pages/SpecialOffers/index';
// import Membership from './pages/Membership/index';
// import About from './pages/About/index';
// import Inquiry from './pages/Inquiry/index';
import Centers from './pages/Centers/index';
import Events from './pages/Events/index';
import News from './pages/News/index';
import Navigation from './components/Navigation/Nav';
import ScrollToTop from './components/ScrollToTop';
import Profile from './pages/Profile/index';
// import Book from './pages/Book/index';
// import SixCourt from './pages/SixCourt/index';
// import EightCourt from './pages/EightCourt/index';
// import TennisCourt from './pages/TennisCourt/index';
// import BadmintonCourt from './pages/BadmintonCourt/index';
// import PaymentPage from './components/PaymentPage';
// import CourtSuccess from './pages/CourtSuccess/index';
// import CourtFailed from './pages/CourtFailed/index';


import Cinema from './pages/Cinema/index';
// import PaymentPreviewCinema from './pages/PaymentPreviewCinema/index';
// import BuyTickets from './pages/BuyTickets/index';
// import PaymentResponse from './pages/PaymentResponse/index';
// import TermsConditions from './pages/TermsConditions/index';
// import Privacy from './pages/PrivacyPolicy/index';
// import Success from './pages/Success/index';
// import Failed from './pages/Failed/index';

import ForgotPassword from './pages/ForgotPassword/index';
import DeleteAccount from './pages/DeleteAccount/index';
import LoginPrivacyPolicy from './components/LoginPrivacyPolicy/index';
import LoginTermsConditions from './components/LoginTermsConditions/index';
// import ProgramPopup from './components/ProgramPopup';

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        {/* <ProgramPopup /> */}
        <Routes >
          <Route path="/" element={<Home/>} />

          {/* <Route path="/facilities" element={<Facilities/>} />
          <Route path="/offers" element={<SpecialOffers/>} /> */}
          <Route path="/centers" element={<Centers/>} />
          {/* <Route path="/membership" element={<Membership/>} /> */}
          <Route path="/events" element={<Events/>} />
          <Route path="/news" element={<News/>} />
          <Route path="/profile" element={<Profile />} />
          {/* <Route path="/contact" element={<About/>} />
          <Route path="/inquiry" element={<Inquiry/>} /> */}

          {/* Court Booking Landing Page */}
          {/* <Route path="/book" element={<Book/>} /> */}

          {/* Court Booking Pages */}
          {/* <Route path="/sixcourt" element={<SixCourt />} />
          <Route path="/eightcourt" element={<EightCourt />} />
          <Route path="/tenniscourt" element={<TennisCourt />} />
          <Route path="/badmintoncourt" element={<BadmintonCourt />} /> */}

          {/* Court Booking Payment Page */}
          {/* <Route path="/paymentpage" element={<PaymentPage />} /> */}

          {/* Court Booking Payment Success and Failed Message */}
          {/* <Route path="/courtsuccess" element={<CourtSuccess />} />
          <Route path="/courtfailed" element={<CourtFailed />} /> */}

          {/* Cinema Landing Page */}
          <Route path="/cinema" element={<Cinema/>} />
          {/* Cinema Ticket Booking Page */}
          {/* <Route path="/buytickets/:id" element={<BuyTickets />} /> */}

          {/* Cinema Payment Details Page */}
          {/* <Route path="/paymentpreviewcinema" element={<PaymentPreviewCinema/>} /> */}
          
          {/* <Route path="/privacypolicy" element={<Privacy/>} />
          <Route path="/buytickets/:id" element={<BuyTickets />} /> */}
          {/* Cinema Payment Success and Failed Message */}
          {/* <Route path="/success" element={<Success />} />
          <Route path="/failed" element={<Failed />} /> */}

          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/privacy-policy" element={<LoginPrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<LoginTermsConditions />} />
          <Route path="/deleteaccount" element={<DeleteAccount />} />
        </Routes>
        <Footer/>
        <MemberPop />
      </BrowserRouter>
    </>
  )
}

export default App
